var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalvadorCaetanoLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "199.74 316.47 966.54 135.02",
    width: 966.54,
    height: 135.02,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_24-2",
    x1: -53.58,
    y1: 820.62,
    x2: -41.97,
    y2: 837.6,
    xlinkHref: "#Gradiente_sem_nome_24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_24",
    x1: -43.06,
    y1: 853.86,
    x2: -43.06,
    y2: 853.86,
    gradientTransform: "translate(939.67 972.66) rotate(135.98)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ac6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_16-2",
    x1: 215.84,
    y1: 1028.28,
    x2: 188.85,
    y2: 1007.1,
    xlinkHref: "#Gradiente_sem_nome_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_16",
    x1: 204.4,
    y1: 1038.87,
    x2: 204.4,
    y2: 1038.87,
    gradientTransform: "matrix(-0.97, -0.22, 0.22, -0.97, 381.37, 1407.99)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6ac6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#64b6e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#558eb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#3d4e58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_24-4",
    x1: 502.25,
    y1: 929.99,
    x2: 521.35,
    y2: 937.63,
    gradientTransform: "translate(-207.95 1281.85) rotate(-116.6)",
    xlinkHref: "#Gradiente_sem_nome_24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_24-6",
    x1: 590.07,
    y1: 590.06,
    x2: 607.75,
    y2: 623.11,
    gradientTransform: "translate(-456.09 618.8) rotate(-59.69)",
    xlinkHref: "#Gradiente_sem_nome_24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_16-4",
    x1: 344.17,
    y1: 381.95,
    x2: 326.62,
    y2: 374.06,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Gradiente_sem_nome_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_24-7",
    x1: 368.91,
    y1: 329.23,
    x2: 350.2,
    y2: 364.09,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Gradiente_sem_nome_24"
  }), /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#333;}.cls-2{fill:url(#Gradiente_sem_nome_24);}.cls-3{fill:url(#Gradiente_sem_nome_24-2);}.cls-4{fill:url(#Gradiente_sem_nome_16);}.cls-5{fill:url(#Gradiente_sem_nome_16-2);}.cls-6{fill:url(#Gradiente_sem_nome_24-3);}.cls-7{fill:url(#Gradiente_sem_nome_24-4);}.cls-8{fill:url(#Gradiente_sem_nome_24-5);}.cls-9{fill:url(#Gradiente_sem_nome_24-6);}.cls-10{fill:url(#Gradiente_sem_nome_16-3);}.cls-11{fill:url(#Gradiente_sem_nome_16-4);}.cls-12{fill:url(#Gradiente_sem_nome_24-7);}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M229.74,423.24a30,30,0,0,1-30-30v-45a30,30,0,0,1,30-30h64.95a7.51,7.51,0,0,1,7.19,5.34h0a7.51,7.51,0,0,1-7.19,9.66H229.74a15,15,0,0,0-15,15v45a15,15,0,0,0,15,15h52.52a7.5,7.5,0,0,0,7.51-7.5v-30a7.5,7.5,0,0,1,7.5-7.5h0a7.5,7.5,0,0,1,7.5,7.5v45a7.5,7.5,0,0,1-7.5,7.51Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M517.91,421.52a30,30,0,0,1-30-30v-45a30,30,0,0,1,30-30h65a7.49,7.49,0,0,1,7.18,5.34h0a7.51,7.51,0,0,1-7.19,9.66h-65a15,15,0,0,0-15,15v45a15,15,0,0,0,15,15h65a7.51,7.51,0,0,1,7.19,9.66h0a7.51,7.51,0,0,1-7.19,5.35Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M611,316.47h0a7.5,7.5,0,0,1,7.51,7.5v15a7.5,7.5,0,0,0,7.5,7.5H678.5a30,30,0,0,1,30,30V414a7.5,7.5,0,0,1-7.5,7.51h0a7.5,7.5,0,0,1-7.5-7.51V376.5a15,15,0,0,0-15-15H626a7.5,7.5,0,0,0-7.5,7.5v45a7.51,7.51,0,0,1-7.51,7.51h0a7.5,7.5,0,0,1-7.5-7.51V324A7.5,7.5,0,0,1,611,316.47Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M725.69,354.3a11,11,0,0,1,10.5-7.82h67.75a21.64,21.64,0,0,1,21.64,21.64v47.81a5.59,5.59,0,0,1-5.59,5.59h-76.9c-9.63,0-18.52-6-21.41-15.18-4.9-15.59,6.53-29.85,21.36-29.85h62a5.58,5.58,0,0,0,5.58-5.58v-2.79a6.63,6.63,0,0,0-6.63-6.63H731a5.58,5.58,0,0,1-5.35-7.19Zm84.88,46.63v-3.84A5.58,5.58,0,0,0,805,391.5h-62.3a7.58,7.58,0,0,0-6.35,3.86c-2.57,5.77,1.33,11.15,6.7,11.15h62A5.58,5.58,0,0,0,810.57,400.93Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M930.74,351.83h0a7.5,7.5,0,0,1-7.18,9.66H878.11A22.58,22.58,0,0,0,855.6,384v30a7.5,7.5,0,0,1-7.5,7.51h0a7.5,7.5,0,0,1-7.5-7.51V354a7.5,7.5,0,0,1,7.5-7.51h0a7.5,7.5,0,0,1,7.5,7.51v6.3a15.05,15.05,0,0,1,15-13.81h52.95A7.49,7.49,0,0,1,930.74,351.83Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1047.71,350.23v75a26.26,26.26,0,0,1-26.27,26.26H953a3.73,3.73,0,0,1-3.59-2.67l-2.25-7.51a3.75,3.75,0,0,1,3.59-4.83h70.74a11.26,11.26,0,0,0,11.26-11.25h0a3.75,3.75,0,0,0-3.75-3.75h-60a26.27,26.27,0,0,1-26.27-26.26V372.74a26.27,26.27,0,0,1,26.27-26.26h75A3.75,3.75,0,0,1,1047.71,350.23Zm-90,45a11.25,11.25,0,0,0,11.25,11.25h60a3.75,3.75,0,0,0,3.75-3.75V365.24a3.75,3.75,0,0,0-3.75-3.75h-60a11.25,11.25,0,0,0-11.25,11.25Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1141.89,346.48a24.39,24.39,0,0,1,24.39,24.39h0a20.63,20.63,0,0,1-20.63,20.63h-63.79a5.63,5.63,0,0,0-5.63,5.63h0a9.38,9.38,0,0,0,9.38,9.38H1151a9.16,9.16,0,0,1,8.78,11.79l-.57,1.88a1.87,1.87,0,0,1-1.79,1.34h-71.77a24.38,24.38,0,0,1-24.38-24.39V370.87a24.38,24.38,0,0,1,24.38-24.39Zm-56.28,15a9.38,9.38,0,0,0-9.38,9.38h0a5.62,5.62,0,0,0,5.63,5.62h63.78a5.62,5.62,0,0,0,5.63-5.62h0a9.38,9.38,0,0,0-9.38-9.38Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M458.36,399.6h0a11.46,11.46,0,0,1,11.45,11.46h0a11.45,11.45,0,0,1-11.45,11.45h0a11.46,11.46,0,0,1-11.46-11.45h0A11.46,11.46,0,0,1,458.36,399.6Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M382,334.51a39,39,0,0,1,32.07,29.41c3.64-1.27,7.25-2.53,10.87-3.75a50.52,50.52,0,0,0-41.14-37,5.72,5.72,0,0,0-6.57,5.57h0A5.67,5.67,0,0,0,382,334.51Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M411.7,394.71c-.95-3,.64-7,4.75-7,5.29,0,6.4,6.45,3.37,9.19a8.63,8.63,0,0,1,.2.88,50.5,50.5,0,0,0,2.07-45.66,5.73,5.73,0,0,0-8.26-2.46h0a5.67,5.67,0,0,0-2.2,7.12,39,39,0,0,1-5.18,40.7,6,6,0,0,1,1.14-.11,5.18,5.18,0,0,1,2.49.6A5.2,5.2,0,0,1,411.7,394.71Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M411.29,389.9a39,39,0,0,1-37.67,21.79c.12,3.85.24,7.68.32,11.49A50.53,50.53,0,0,0,421.54,395a5.73,5.73,0,0,0-3.35-7.93h0A5.67,5.67,0,0,0,411.29,389.9Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M381.12,411.49a39,39,0,0,1-38.82-19.67c-3.16,2.2-6.3,4.4-9.45,6.54a50.51,50.51,0,0,0,49.59,24.5,5.73,5.73,0,0,0,4.82-7.14h0A5.67,5.67,0,0,0,381.12,411.49Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M344.23,394.93a39,39,0,0,1-3.14-38.63,4.09,4.09,0,0,1-.7-.33,4.78,4.78,0,0,1-4.87,3.89c-4.55,0-6-4.78-4.39-7.86a4.78,4.78,0,0,1-.38-.61,50.49,50.49,0,0,0,4,49.94,5.72,5.72,0,0,0,8.55,1h0A5.68,5.68,0,0,0,344.23,394.93Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M376.68,317.26h-.25a5.62,5.62,0,0,0-5.59,5.55,50.49,50.49,0,0,0-41.07,30.78,5.73,5.73,0,0,0,3.83,7.71h0a5.67,5.67,0,0,0,6.71-3.26,39,39,0,0,1,30.52-23.69V352a5.62,5.62,0,0,0,5.6,5.6h.25a5.62,5.62,0,0,0,5.6-5.6V322.86A5.62,5.62,0,0,0,376.68,317.26Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalvadorCaetanoLogo);
export default __webpack_public_path__ + "static/media/SalvadorCaetanoLogo.16f22c922454e37d17e56c08161b3665.svg";
export { ForwardRef as ReactComponent };